export default __webpack_public_path__ + "static/media/kazakhstan.c1ea1b08.svg";